import { useState } from "react";
import { comments, peopleCats } from "@/mocks/gossip";

const avatarPalette = ["bg-primary-500", "bg-secondary-500", "bg-accent-500"];

export default function Community() {
  const [tab, setTab] = useState("站方圆桌");
  const tabs = ["站方圆桌", "今日议题", "当事人档案"];
  const shown = comments.filter((c) => c.cat === tab).slice(0, 3);

  return (
    <section id="bbs" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* discussion feed */}
          <div className="lg:col-span-8">
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <span className="grid h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-chat-smile-3-line"></i>
                  </span>
                  <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">围观区</h2>
                </div>
                <p className="mt-1.5 text-sm text-foreground-500">不急着下结论，先看看大家都怎么说</p>
              </div>
              <div className="chip border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-500">
                <i className="ri-community-line"></i>在线 3.2 万
              </div>
            </div>

            {/* composer (decorative) */}
            <div className="mt-5 rounded-xl border border-background-200 bg-background-50 p-3.5 md:p-4">
              <div className="flex items-start gap-3">
                <span className="grid h-9 w-9 shrink-0 items-center justify-center rounded-full bg-foreground-950 text-sm font-bold text-background-50">
                  我
                </span>
                <div className="flex-1">
                  <textarea
                    rows={2}
                    placeholder="理性吃瓜，友善发言，说说你的看法…"
                    className="w-full resize-none bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
                  ></textarea>
                  <div className="mt-1 flex items-center justify-between border-t border-background-100 pt-2.5">
                    <div className="flex items-center gap-1 text-foreground-400">
                      {["image-add-line", "emoji-sticker-line", "at-line", "link"].map((ic, i) => (
                        <button
                          key={ic}
                          aria-label="工具"
                          className="grid h-8 w-8 cursor-pointer items-center justify-center rounded-md text-lg transition-colors hover:bg-background-100 hover:text-primary-600"
                        >
                          <i className={`ri-${ic} ${i === 3 ? "text-base" : ""}`}></i>
                        </button>
                      ))}
                    </div>
                    <button className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600">
                      发布围观
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* topic tabs */}
            <div className="mt-5 flex flex-wrap gap-1.5 rounded-full border border-background-200 bg-background-50 p-1">
              {tabs.map((t) => (
                <button
                  key={t}
                  onClick={() => setTab(t)}
                  className={`flex-1 whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                    tab === t ? "bg-secondary-500 text-background-50" : "text-foreground-600 hover:text-secondary-800"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>

            {/* comment list */}
            <div className="mt-4 space-y-3">
              {shown.map((c, idx) => (
                <article key={c.id} className="rounded-xl border border-background-200 bg-background-50 p-4">
                  <div className="flex items-start gap-3">
                    <span className={`grid h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold text-background-50 ${avatarPalette[idx % avatarPalette.length]}`}>
                      {c.name.slice(0, 1)}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                        <span className="font-heading text-sm font-bold text-foreground-950">{c.name}</span>
                        <span className="chip bg-background-200 px-2 py-0.5 text-[11px] text-secondary-800">{c.role}</span>
                        <span className="chip bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800">
                          <i className="ri-fire-fill text-[9px]"></i>{c.level}
                        </span>
                        <span className="ml-auto text-[11px] text-foreground-400">{c.time}</span>
                      </div>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.text}</p>
                      <div className="mt-3 flex items-center gap-1">
                        <button className="flex cursor-pointer items-center gap-1.5 rounded-md bg-background-100 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                          <i className="ri-thumb-up-line"></i>{c.likes}
                        </button>
                        <button className="flex cursor-pointer items-center gap-1.5 rounded-md bg-background-100 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                          <i className="ri-share-forward-line"></i>转发
                        </button>
                        <button className="flex cursor-pointer items-center gap-1.5 rounded-md bg-background-100 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                          <i className="ri-quote-text"></i>引用
                        </button>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* right rail: mood poll + subscribe-like */}
          <aside className="flex flex-col gap-5 lg:col-span-4">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-scales-3-line text-accent-500"></i>围观风向
              </h3>
              <p className="mt-1 text-xs text-foreground-500">关于「主播团队分家」你觉得是……</p>
              <div className="mt-4 flex items-center justify-between rounded-md bg-primary-50 px-3 py-2">
                <span className="text-sm text-primary-800">节目效果，是剧本</span>
                <span className="font-label text-sm font-bold text-primary-600">62%</span>
              </div>
              <div className="mt-2 flex items-center justify-between rounded-md bg-secondary-50 px-3 py-2">
                <span className="text-sm text-secondary-900">真闹掰了</span>
                <span className="font-label text-sm font-bold text-secondary-700">38%</span>
              </div>
              <div className="mt-3 flex gap-2">
                {["投第一票", "投第二票"].map((b) => (
                  <button
                    key={b}
                    className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-background-200 bg-background-50 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                  >
                    {b}
                  </button>
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between border-t border-dashed border-background-200 pt-3 text-[11px] text-foreground-400">
                <span>已投 4.1 万人次</span>
                <a href="#feed" className="text-primary-600 hover:text-primary-700">去看事件</a>
              </div>
            </div>

            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-primary-500"></i>按人物归档
              </h3>
              <div className="mt-3 flex flex-wrap gap-2">
                {peopleCats.map((c, i) => (
                  <a
                    key={c}
                    href="#feed"
                    className="chip bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
                  >
                    {c}
                    <span className="text-[10px] text-foreground-400">· {[3, 5, 2, 4, 1][i] || 2}8</span>
                  </a>
                ))}
              </div>
              <a href="#feed" className="mt-4 flex items-center gap-2 rounded-md bg-foreground-950 px-3 py-2.5 text-sm text-background-50 transition-opacity hover:opacity-90">
                <i className="ri-search-line text-accent-400"></i>
                搜全网人物 / 事件档案
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}